import { render, staticRenderFns } from "./FPAddPayment.vue?vue&type=template&id=b7cf7cfa"
import script from "./FPAddPayment.vue?vue&type=script&lang=js"
export * from "./FPAddPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports